import { gql } from '@apollo/client';

export const GET_ORG_PAGE_QUERY = gql`
  query GetOrgPage($cursor: String, $limit: Int) {
    me {
      organizationPage(cursor: $cursor, limit: $limit) {
        organizations {
          id
          name
        }
        cursor
      }
    }
  }
`;

export const GET_ORG_VENUE_STORES = gql`
  query GetVenueStores {
    venues {
      id
      name
      stores {
        id
        name
      }
    }
  }
`;

export const GET_DEVICES = gql`
  query GetDevices($filters: GetDevicesFiltersInput) {
    devices(filters: $filters) {
      id
      name
      mode
      isPaired
      uuid
    }
  }
`;
